import React, { useState } from 'react';

const StatusLight = ({ status, onClick, isClickable, loading }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const statusConfig = {
    Draft: {
      color: '#FCD34D',
      darkColor: '#EAB308',
      label: 'Draft'
    },
    Confirmed: {
      color: '#38BDF8',
      darkColor: '#0EA5E9',
      label: 'Confirmed'
    },
    Issued: {
      color: '#F59E0B',
      darkColor: '#D97706',
      label: 'Issued'
    },
    'In Progress': {
      color: '#60A5FA',
      darkColor: '#3B82F6',
      label: 'In Progress'
    },
    'Partly Paid': {
      color: '#60A5FA',
      darkColor: '#3B82F6',
      label: 'Partly Paid'
    },
    Submitted: {
      color: '#F59E0B',
      darkColor: '#D97706',
      label: 'Submitted'
    },
    Approved: {
      color: '#10B981',
      darkColor: '#059669',
      label: 'Approved'
    },
    Rejected: {
      color: '#EF4444',
      darkColor: '#DC2626',
      label: 'Rejected'
    },
    Paid: {
      color: '#10B981',
      darkColor: '#059669',
      label: 'Paid'
    },
    Completed: {
      color: '#10B981',
      darkColor: '#059669',
      label: 'Completed'
    },
    Cancelled: {
      color: '#9CA3AF',
      darkColor: '#6B7280',
      label: 'Cancelled'
    }
  };

  const config = statusConfig[status] || statusConfig.Draft;

  return (
    <>
      <div
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          cursor: isClickable && !loading ? 'pointer' : 'default',
          opacity: loading ? 0.6 : 1,
          pointerEvents: loading ? 'none' : 'auto',
          position: 'relative'
        }}
        onClick={() => isClickable && !loading && onClick && onClick()}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <div style={{ position: 'relative', display: 'inline-flex' }}>
          <div
            style={{
              width: '12px',
              height: '12px',
              borderRadius: '50%',
              backgroundColor: config.color,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.2s ease',
              boxShadow: isClickable ? `0 0 8px ${config.color}80` : 'none',
              ':hover': isClickable ? {
                backgroundColor: config.darkColor,
                boxShadow: `0 0 12px ${config.color}B3`
              } : {}
            }}
            onMouseEnter={(e) => {
              if (isClickable && !loading) {
                e.currentTarget.style.backgroundColor = config.darkColor;
                e.currentTarget.style.boxShadow = `0 0 12px ${config.color}B3`;
              }
            }}
            onMouseLeave={(e) => {
              if (isClickable && !loading) {
                e.currentTarget.style.backgroundColor = config.color;
                e.currentTarget.style.boxShadow = `0 0 8px ${config.color}80`;
              }
            }}
          />
          {showTooltip && (
            <div
              style={{
                position: 'absolute',
                bottom: '100%',
                left: '50%',
                transform: 'translateX(-50%)',
                marginBottom: '8px',
                backgroundColor: '#1F2937',
                color: '#FFFFFF',
                padding: '6px 12px',
                borderRadius: '4px',
                fontSize: '12px',
                fontWeight: '500',
                whiteSpace: 'nowrap',
                zIndex: 1000,
                pointerEvents: 'none',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                animation: 'fadeIn 0.2s ease'
              }}
            >
              {config.label}
              <div
                style={{
                  position: 'absolute',
                  top: '100%',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  borderLeft: '4px solid transparent',
                  borderRight: '4px solid transparent',
                  borderTop: '4px solid #1F2937',
                  width: 0,
                  height: 0
                }}
              />
            </div>
          )}
        </div>
        <span
          style={{
            fontSize: '12px',
            fontWeight: '500',
            color: '#374151',
            whiteSpace: 'nowrap',
            minWidth: '70px'
          }}
        >
          {loading ? 'Loading...' : config.label}
        </span>
      </div>

      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateX(-50%) translateY(4px);
          }
          to {
            opacity: 1;
            transform: translateX(-50%) translateY(0);
          }
        }
      `}</style>
    </>
  );
};

export default StatusLight;
